export default __webpack_public_path__ + "static/media/track04.5c882bf6.jpg";